<div class="contact-container">
  <div class="container">
    <h1 [@slideInDown]="slideInDown">Reach Me Out</h1>
    <div class="contact-flex">
      <div id="flex-item" class="flex-item">
        <h2>Contact Me!</h2>
        <h3>Mr.Naresh Kumar,</h3>
        <h4>Full Stack Web Developer</h4>
        <div [@fadeInUp]="fadeInUp" class="contact-flex">
          <div class="contact-tech">
            <img src="../../../assets/WhatsApp_Logo_1.png" class="tech-item" alt="" srcset="">
            <h5 class="detail">+91 790 430 3142</h5>
          </div>
          <div [@fadeInUp]="fadeInUp" class="contact-tech">
            <img src="../../../assets/gmail.png" class="tech-item" alt="" srcset="">
            <h5 class="detail">nareshkmr219@gmail.com</h5>
          </div>
          <div [@fadeInUp]="fadeInUp" class="contact-tech">
            <img src="../../../assets/location.png" class="tech-item" alt="" srcset="">
            <p>20 SSR Street,Chennai,TamilNadu,India</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
